export function resetStore({ commit, store }) {
    commit('resetStore')
}
